<template>
  <div>
    <h2 class="mb-4">Composition of an Alloy: Constants</h2>
    <v-form>
      <!-- Constants Table -->
      <v-textarea
        v-model="inputs.constants_table_caption"
        label="Table Caption"
        outlined
        rows="1"
        class="mb-n3"
        auto-grow
        placeholder="Write a caption for the constants table here."
      />
      <v-simple-table>
        <thead>
          <tr>
            <td>&nbsp;</td>
            <td style="font-weight: bold; text-align: center">Value</td>
            <td style="font-weight: bold; text-align: center">Units</td>
            <td style="font-weight: bold; text-align: center">Reference</td>
          </tr>
        </thead>
        <tr v-for="{key, label} in constants" :key="key">
          <td style="width: 15%">{{ label }}</td>
          <td style="width: 17%">
            <calculation-input v-model="inputs[`constants_${key}`]" class="centered-input" />
          </td>
          <td style="width: 28%">
            <v-select
              v-model="inputs[`constants_${key}_units`]"
              :items="units"
              item-value="key"
              outlined
              hide-details
            >
              <template #item="{item}">
                <stemble-latex :content="item.label" />
              </template>
              <template #selection="{item}">
                <stemble-latex class="no-text-transform" :content="item.label" />
              </template>
            </v-select>
          </td>
          <td style="width: 40%">
            <v-text-field v-model="inputs[`constants_${key}_reference`]" outlined hide-details />
          </td>
        </tr>
      </v-simple-table>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import CalculationInput from '@/tasks/components/inputs/CalculationInput.vue';
import StembleLatex from '@/tasks/components/StembleLatex.vue';

export default {
  name: 'OttawaLab1ReportConstantsTable',
  components: {StembleLatex, CalculationInput},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        constants_table_caption: null,
        constants_molarMassZn: null,
        constants_molarMassMg: null,
        constants_molarMassAl: null,
        constants_densityOfWater: null,
        constants_idealGasConstant: null,
        constants_molarMassZn_units: null,
        constants_molarMassMg_units: null,
        constants_molarMassAl_units: null,
        constants_densityOfWater_units: null,
        constants_idealGasConstant_units: null,
        constants_molarMassZn_reference: null,
        constants_molarMassMg_reference: null,
        constants_molarMassAl_reference: null,
        constants_densityOfWater_reference: null,
        constants_idealGasConstant_reference: null,
      },
      constants: [
        {key: 'molarMassZn', label: 'Molar Mass of Zinc'},
        {key: 'molarMassMg', label: 'Molar Mass of Magnesium'},
        {key: 'molarMassAl', label: 'Molar Mass of Aluminum'},
        {key: 'densityOfWater', label: 'Density of Water'},
        {key: 'idealGasConstant', label: 'Ideal Gas Constant'},
      ],
      units: [
        {key: 'g', label: '$\\text{g}$'},
        {key: 'kPa', label: '$\\text{kPa}$'},
        {key: 'mL', label: '$\\text{mL}$'},
        {key: 'gPerMol', label: '$\\text{g} \\cdot \\text{mol}^{-1}$'},
        {key: 'degreesCelsius', label: '$^\\omicron\\text{C}$'},
        {key: 'gramsPerMillilitre', label: '$\\text{g} \\cdot \\text{mL}^{-1}$'},
        {
          key: 'joulesPerKelvinPerMole',
          label: '$\\text{J} \\cdot \\text{K}^{-1} \\cdot \\text{mol}^{-1}$',
        },
        {
          key: 'moles',
          label: '$\\text{mol}$',
        },
        {
          key: 'percent',
          label: '$\\text{\\%}$',
        },
      ],
    };
  },
};
</script>
